import React from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'brand' | 'accent';
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CtaButton({
  children,
  variant = 'brand',
  className = '',
  onClick,
  href
}: CtaButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg font-bold rounded-xl transition-all duration-300 transform hover:scale-105 active:scale-95 text-black no-underline';
  const variantClasses = variant === 'brand' ? 'bg-brand hover:bg-brandHover animate-pulse-glow' : 'bg-accent hover:bg-accentHover animate-pulse-glow-accent';
  if (href) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} {...href.startsWith('http') ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} className={`${baseClasses} ${variantClasses} ${className}`} data-id="element-65">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`${baseClasses} ${variantClasses} ${className}`} data-id="element-66">
      {children}
    </motion.button>;
}